export default __webpack_public_path__ + "static/header-other-9dec154175fe452c21100a0f782584af.jpg";